import '../../styles/generic.css';
import '../../styles/header.css';

import { _ } from '../../utils/l10n';
import { HeroHeader } from '../homePage/HeroHeader';
import { NavigationLinksProps, NavigationList } from './NavigationList';

export interface HeaderProps extends NavigationLinksProps {
  /**
   * Class name for the header
   */
  headerClassName?: string;
}

export const Header = (
  {
    isHomePage,
    darkLogo,
    headerClassName,
  }: HeaderProps,
) => (
  <div className={`page-header ${isHomePage ? 'home-page network-bg' : 'gradient-bg'} ${headerClassName}`}>
    <NavigationList isHomePage={isHomePage} darkLogo={darkLogo} />
    {isHomePage && <HeroHeader />}
  </div>
);
